import { Check, TaskView } from '@doist/icons/base'
import { Text } from '@doist/marketist'

import cn from 'clsx'
import { useTranslation } from 'next-i18next'

import css from './AvailableInPlan.module.css'

type Props = {
    isOn: boolean
    className?: string
}

function ExperimentalFeatureStatusTag({ isOn, className, ...rest }: Props) {
    const { t } = useTranslation('helpcenter')
    return (
        <div className={cn(css.statusTag, !isOn ? css.unavailable : null, className)} {...rest}>
            {isOn ? <Check /> : <TaskView />}
            <Text size="body-2xs">{t('article.experimentalFeature')}</Text>
        </div>
    )
}

export { ExperimentalFeatureStatusTag }
export type { Props }
